import { Logging } from "@/data/util/Logging";

import { config } from "@/operator/Operator";
import { ProductionContext } from "@/operator/context/ProductionContext";

export class ProductionViewFocusMonitor {
    public lastBlurTime?: Date;
    private context: ProductionContext;
    private focusHandler: any;
    private blurHandler: any;

    constructor(context: ProductionContext) {
        this.context = context;
    }

    public enable() {
        this.focusHandler = this.onFocus.bind(this);
        this.blurHandler = this.onBlur.bind(this);

        window.addEventListener("focus", this.focusHandler);
        window.addEventListener("blur", this.blurHandler);
    }

    public disable() {
        if (this.focusHandler != null) window.removeEventListener("focus", this.focusHandler);

        if (this.blurHandler != null) window.removeEventListener("blur", this.blurHandler);
    }

    private async onFocus() {
        Logging.LogTrace("Window focus");

        const windowNotFocusedSeconds = this.getWindowNotFocusedSeconds();
        if (windowNotFocusedSeconds > config.refreshFulfillmentAfterWindowNotFocusedForSeconds) {
            Logging.LogDebug("Window not active for too long. Updating fulfillments");
            await this.context.refreshFulfillments();
        }
    }

    private onBlur() {
        Logging.LogTrace("Window blur");

        this.lastBlurTime = new Date();
    }

    private getWindowNotFocusedSeconds() {
        const currentDate = new Date();
        const notFocusedMilliseconds = currentDate.getTime() - (this.lastBlurTime ?? currentDate).getTime();
        return notFocusedMilliseconds / 1000;
    }
}
